import { DropdownOption, FormFieldMultiSelectValues } from "../../../interface";

export function toSelectedValueArray(selectedByValue: FormFieldMultiSelectValues): string[] {
  return Object.entries(selectedByValue)
    .filter(([_, isSelected]) => !!isSelected).map(([value]) => value);
}

// Local calendar date, not UTC: toISOString() shifts a date picked west of
// Greenwich back to the previous day.
export function toDateInputString(date?: Date): string {
  if (!date || isNaN(date.getTime())) {
    return '';
  }
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

// String-only reformat of a YYYY-MM-DD value to MM/DD/YYYY - no Date parsing,
// so no timezone shift.
export function toUsDateString(isoDate: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate || '');
  if (!match) {
    return isoDate || '';
  }
  return `${match[2]}/${match[3]}/${match[1]}`;
}

export function filterOptions(options: DropdownOption[], searchString: string): DropdownOption[] {
  if (!searchString) {
    return options;
  }
  const terms = searchString.toLocaleLowerCase().split(' ').map(term => term.trim()).filter(term => !!term);
  return options.filter(({ label }) => 
    terms.some(term => label.toLocaleLowerCase().includes(term))
  );
}